import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
import {
	editFormInput as editFormInputReducer,
  editImageInput as editImageInputReducer,
	toEditForm as toEditFormReducer,
	setInputValidation as setInputValidationReducer,
  setSelectedFile as setSelectedFileReducer,
  setImageSize as setImageSizeReducer,
  setNextFile as setNextFileReducer,
} from './reducer';

export const checkInStep1Slice = createSlice({
  name: 'forms',
  initialState: initialState,
  reducers: {
    editFormInput: editFormInputReducer,
    editImageInput: editImageInputReducer,
    toEditForm: toEditFormReducer,
    setInputValidation: setInputValidationReducer,
    setSelectedFile: setSelectedFileReducer,
    setImageSize: setImageSizeReducer,
    setNextFile: setNextFileReducer,
  },
});

export const { editFormInput, editImageInput, toEditForm, setInputValidation, setSelectedFile, setImageSize, setNextFile } = checkInStep1Slice.actions;

export const getInputData = (view, object, input) => {
  return (state) => state.forms[view][object].form[input];
};

export const getInputValid = (view, object, input) => {
  return (state) => state.forms[view][object].form[input].validation.valid;
};

export const getPersonalDocuments = (state) => state.forms.checkin2.files.form;
export const getSelectedFile = (state) => state.forms.checkin2.files.selectedFile;
export const getNextFile = (state) => state.forms.checkin2.files.nextFile;


export const getSelectedActualControl = (state) => state.forms.checkin2.files.form[state.forms.checkin2.files.selectedFile];


export const getPersonalDocumentsArray = (state) => {
  return Object.keys(state.forms.checkin2.files.form).map((k) => state.forms.checkin2.files.form[k]);
};

export default checkInStep1Slice.reducer;
